/**
 * @fileOverview File with Account Header Links component
 * @description File containing AccountHeaderLinks function
 * @author Komal Chevli
 * @since 1.0.0
 */

import React from "react";
import { Link } from "react-router-dom";

class AccountHeaderLinks extends React.Component {
  render() {
    const { image } = this.props;
    return (
      <div className="nav-bar">
        <h1 className="logo">
          <Link to="/account/login"><img src={image} alt="..." height="40px" width="230px" /></Link>
        </h1>
      </div>
    );
  }
}

export default (AccountHeaderLinks);
